import React from 'react';
import { LocalityType } from '@domain-group/fe-allhomes-library';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
var DistrictIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-shared-components/static/icon-district_0b090411.svg";
var DivisionIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-shared-components/static/icon-division_0b090411.svg";
var StreetIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-shared-components/static/icon-street_341d161d.svg";
var PropertyIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-shared-components/static/icon-property_71694539.svg";
import * as styles from './locality-link-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var IconMap = {
  [LocalityType.DIVISION.type]: DivisionIcon,
  [LocalityType.DISTRICT.type]: DistrictIcon,
  [LocalityType.STREET.type]: StreetIcon
};
var LocalityLinkCard = _ref => {
  var id = _ref.id,
    _ref$hasBorder = _ref.hasBorder,
    hasBorder = _ref$hasBorder === void 0 ? true : _ref$hasBorder,
    _ref$asDiv = _ref.asDiv,
    asDiv = _ref$asDiv === void 0 ? false : _ref$asDiv,
    title = _ref.title,
    localityType = _ref.localityType,
    text = _ref.text,
    link = _ref.link,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    className = _ref.className,
    _ref$arrowPosition = _ref.arrowPosition,
    arrowPosition = _ref$arrowPosition === void 0 ? 'end' : _ref$arrowPosition;
  var Tag = asDiv ? 'div' : 'a';
  var iconSrc = IconMap[localityType] || PropertyIcon;
  return ___EmotionJSX(Tag, {
    href: link,
    css: styles.container(hasBorder),
    id: id,
    onClick: onClick,
    className: className
  }, ___EmotionJSX("div", {
    css: styles.iconContainer
  }, ___EmotionJSX("img", {
    src: iconSrc,
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.linkContainer(arrowPosition === 'even')
  }, ___EmotionJSX("div", {
    css: styles.textContainer
  }, ___EmotionJSX("div", {
    css: styles.title
  }, title), ___EmotionJSX("div", {
    css: styles.text
  }, text)), ___EmotionJSX(ChevronRightIcon, {
    css: styles.chevron
  })));
};
export default LocalityLinkCard;